<script>
import deepLink from '@/mixins/deeplink.js'
import { mapState } from 'vuex'

export default {
  name: 'CallOptionsModal',
  components: {},
  mixins: [deepLink()],
  props: {
    texts: {
      type: Object,
      required: true,
    },
    callData: {
      type: Object,
      required: true,
    },
    query: {
      type: Object,
      required: true,
    },
    router: {
      type: Object,
      required: true,
    },
    dispatchCallSelection: {
      type: Function,
      required: true,
    },
    dispatchShowCallSelection: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {}
  },
  computed: {
    ...mapState('widgets', ['common']),
    showWebCallButton () {
      // return this.callData.show
      return false
    },
    showPstnButton () {
      const { phonenumber_pstn: phonenumberPstn } = this.callData
      return phonenumberPstn !== null && phonenumberPstn !== ''
    },
  },
  mounted () {
    const { showWebCallButton, showPstnButton } = this
    this.dispatchShowCallSelection({ showPstnButton, showWebCallButton })
  },
  methods: {
    callWeb () {
      this.$emit('close')
      this.dispatchCallSelection('WEB')
      this.router.push({
        name: 'screen',
        params: { screenId: 'SAM_WEB_CALL' },
        query: this.query,
      })
    },
    callPstn () {
      this.$emit('close')
      this.dispatchCallSelection('PSTN')
      this.callPhone(this.callData.phonenumber_pstn)
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.container__header">
      <h4>{{ texts.title }}</h4>
    </div>
    <div :class="$style.container__actions">

      <BaseButton
        v-if="showPstnButton"
        @click="callPstn(callData.phonenumber_pstn)"
      >
        {{ texts.phoneTitle }}
        <BaseIcon
          :class="$style.icon"
          name="phone"
        />
        <!-- <img
          src="@assets/images/tel@2x.png"
          style="max-height: 1.6rem; max-width: 1.6rem;"> -->
      </BaseButton>

      <BaseButton
        v-if="showWebCallButton"
        @click="callWeb()"
      >
        {{ texts.dataTitle }}
        <BaseIcon
          :class="$style.icon"
          name="data"
        />
      </BaseButton>
    </div>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  &__header {
    width: 100%;
  }

  h4 {
    @extend %typography-medium;

    text-align: center;
  }

  &__actions {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    margin: 1rem 0 1rem 0;

    button {
      width: 40%;
      height: 3rem;

      // font-weight: bold;
      // color: $primary-green;
      // background-color: transparent;
      // height: 3rem;
      // border-radius: 50%;
    }
  }
}

.icon {
  margin-left: 0.3rem;
}
</style>
